import { useEffect } from 'react';
import { useDispatch, useSelector } from 'shared/hooks';
import analytics from 'shared/utility/analytics';
import { CurrencyInput } from 'shared/inputs';
import { Heading, LabelText } from 'shared/components';
import { InputsContainer } from 'shared/containers';
import { SYNC, sync } from 'shared/wizard/actions';

const WizardLanding = () => {
  const dispatch = useDispatch();
  const {
    input: { rent_per_month },
    output: { errors },
  } = useSelector(state => state);
  useEffect(() => {
    dispatch({
      type: SYNC,
      syncing: false,
    });
    analytics.send('Navigeer', 'Voorpagina');
  }, []);

  return (
    <>
      <Heading>Je situatie</Heading>
      <InputsContainer>
        <LabelText>Je huurlasten per maand</LabelText>
        <CurrencyInput
          id="rent_per_month"
          onChange={sync(dispatch)('rent_per_month')}
          value={rent_per_month}
          errors={errors.rent_per_month}
          placeholder="Bedrag"
        />
      </InputsContainer>
    </>
  );
};

export default WizardLanding;
